import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faDesktop, faMobileAlt, faTools, faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

import FooterPage from '../components/footer'
import HeaderPage from '../components/Header';

function Home() {
  const whatsappNumber = "5541997825871";
  const whatsappMessage = "Olá, estou entrando em contato pelo site Plugintech!";
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <>
      <HeaderPage />

      {/* Hero Section */}
      <section className="hero-section-bg py-5" id="inicio">
        <div className="hero-overlay">
          <Container>
            <Row className="text-center align-items-center min-vh-60">
              <Col>
                <h1 className="display-4 fw-bold text-white mb-4">Bem-vindo a PluginTech!</h1>
                <div className="hero-divider mx-auto mb-4"></div>
                
                <p className="lead text-white-75 mx-auto" style={{ maxWidth: '600px' }}>
                  Fornecemos produtos e serviços técnicos de qualidade, visando a satisfação de
                  nossos clientes, com foco na confiança e na honestidade!
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      <main>
        {/* Serviços Section */}
        <section id="servicos" className="py-5 bg-light">
          <h2 className="mb-4 text-center text-primary py-5">Nossos produtos & serviços</h2>
          <Container>
            <Row className="g-4">
              {/* Assistência para Computadores */}
              <Col lg={4} md={6}>
                <Card className="shadow-sm border-0">
                  <Card.Body className="text-center p-4">
                    <FontAwesomeIcon icon={faDesktop} size="3x" className="text-primary mb-3" />
                    <Card.Title className="h5 mb-3">Assistência para<br></br>computadores & notebooks</Card.Title>
                    <Card.Text className="text-muted mb-4">
                      Prestamos diversos serviços na área de informática, como formatação, backup, limpeza, upgrade, instalação de programas e suporte técnico! 
                      Entre em contato e faça uma cotação!
                    </Card.Text>
                    <Button
                      href={whatsappUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success"
                    >
                      <FontAwesomeIcon icon={faWhatsapp} className="me-2" />
                      WhatsApp
                    </Button>
                  </Card.Body>
                </Card>
              </Col>

              {/* Acessórios para Celulares */}
              <Col lg={4} md={6}>
                <Card className="h-100 shadow-sm border-0">
                  <Card.Body className="text-center p-4">
                    <FontAwesomeIcon icon={faMobileAlt} size="3x" className="text-primary mb-3" />
                    <Card.Title className="h5 mb-3">Comércio de acessórios de<br></br>informática & telefonia</Card.Title>
                    <Card.Text className="text-muted mb-4">
                      Temos diversos acessórios como teclados, mouses, cabos de vídeo e de força, Pendrives, fontes, SSD, Headset, capas, películas, carregadores, fones,
                      suportes e outros.
                    </Card.Text>
                    <Button
                      href={whatsappUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success"
                    >
                      <FontAwesomeIcon icon={faWhatsapp} className="me-2" />
                      WhatsApp
                    </Button>
                  </Card.Body>
                </Card>
              </Col>

              {/* Montagem de Computadores */}
              <Col lg={4} md={6}>
                <Card className="h-100 shadow-sm border-0">
                  <Card.Body className="text-center p-4">
                    <FontAwesomeIcon icon={faTools} size="3x" className="text-primary mb-3" />
                    <Card.Title className="h5 mb-3">Montagem de computadores <br></br>novos & semi-novos</Card.Title>
                    <Card.Text className="text-muted mb-4">
                      Computadores da linha home, office e Gamers. Trabalhamos com peças novas e seminovas. Traga seu setup e seus requisitos
                      que fazemos a montagem! Entre em contato e faça uma cotação!
                    </Card.Text>
                    <Button
                      href={whatsappUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success"
                    >
                      <FontAwesomeIcon icon={faWhatsapp} className="me-2" />
                      WhatsApp
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Endereço Section */}
        <section id="contato" className="py-5 bg-light">
          <h2 className="mb-4 text-center text-primary">Conheça nossa loja!</h2>
          <Container>
           <Row>
              <Col lg={12}>
                
                <Row className="g-4">
                  {/* Informações de Contato */}
                  <Col lg={6}>
                    <Card className="shadow-sm border-0 h-100">
                      <Card.Body className="p-4">
                        <div className="mb-4">
                          <FontAwesomeIcon icon={faMapMarkerAlt} className="text-primary me-2" size="lg" />
                          <span className="fw-bold fs-5">Rua Nova Esperança, n° 1709, Sítio Cercado, Curitiba - PR</span>
                        </div>

                        <div className="mb-4">
                          <FontAwesomeIcon icon={faPhone} className="text-primary me-2" size="lg" />
                          <span className="fw-bold fs-5">Telefone: </span>
                          <a href="tel:+5541997825871" className="text-decoration-none fw-bold fs-5">(41) 9 9782-5871</a>
                        </div>
                        <div className="mb-4">
                          <FontAwesomeIcon icon={faEnvelope} className="text-primary me-2" size="lg" />
                          <span className="fw-bold fs-5">E-mail: </span>
                          <a href="mailto:tecnico@plugintech.com.br" className="text-decoration-none fw-bold fs-5">tecnico@plugintech.com.br</a>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  {/* Mapa do Google Maps */}
                  <Col lg={6}>
                    <Card className="shadow-sm border-0 h-100">
                      <Card.Body className="p-0">
                        <div className="map-container">
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3603.499!2d-49.350747!3d-25.4489996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94dce4b51d8e8d8d%3A0x7f7f7f7f7f7f7f7f!2sR.%20Nova%20Esperan%C3%A7a%2C%201709%20-%20S%C3%ADtio%20Cercado%2C%20Curitiba%20-%20PR%2C%2081925-550%2C%20Brasil!5e0!3m2!1spt-BR!2sbr!4v1704067200000!5m2!1spt-BR!2sbr"
                            width="100%"
                            height="300"
                            style={{ border: 0, borderRadius: '8px' }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Localização PluginTech - Rua Nova Esperança, 1709, Sítio Cercado, Curitiba"
                          ></iframe>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </main>

      <FooterPage />
    </>
  );
}

export default Home;
